import {
  fork,
  call,
  put,
  all,
  takeEvery,
  takeLatest
} from "redux-saga/effects";
import asyncInterface from "../../asyncInterface";
import history from "../../history/history";
import { handlerServerSideErrorsGlobal } from "../../sagas/globalSaga";
import { profile, postJson } from "../../services/apiServices";
import ConstVals from "./constants";
import * as globalActionTypes from "../../actions/globalActionTypes";
import * as actionNameTypes from "./actionType";
const { getAccountProfileLegacyByAccountIdAndPartyId } = profile;

export function fetchAccountData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.myAccount.fetchAccountData(fetchPayload);
}
export function submitData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.myAccount.submitData(fetchPayload);
}

/*************************** SAGA FOR FETCH ACCOUNT DATA ******************************/
export function* fetchAccountDataWatcher() {
  yield takeEvery(actionNameTypes.fetchMyAccDataType, fetchAccountDataWorker);
}
export function* fetchAccountDataWorker(data) {
  yield put({
    type: actionNameTypes.fetchMyAccDataLoaderType,
    payload: ""
  });
  try {
    const response = yield call(
      getAccountProfileLegacyByAccountIdAndPartyId,
      data.payload
    );
    yield put({
      type: actionNameTypes.myAccDataType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionNameTypes.myAccDataFailedType,
      error
    }); 
    yield  handlerServerSideErrorsGlobal({error,type:"myAccountPageErr",errorCodes:[503],redirect:'/',isRedirectfirst:true});
    yield  handlerServerSideErrorsGlobal({error,errorCodes:[500],redirect:'/',isRedirectfirst:true});
  }
}

export function* fetchAccountMappingWorker(fetchPayload) {
  yield call(getCountriesList, fetchPayload.payload.metaData);
}

export function* fetchProfileNameWorker(fetchPayload) {
  yield put({
    type: "GET_PROFILE_NAME_LOADING"
  });
  try {

    const response = yield call(
      fetchAccountData,
      fetchPayload.payload.metaData
    );

    yield put({
      type: "GET_PROFILE_NAME_SUCCESS",
      payload: response.data.profileSummary.name
    });
  } catch (error) {}
}

export function* fetchAccountMappingWatcher() {
  yield takeEvery(actionNameTypes.fetchMyAccMappingType, fetchAccountMappingWorker);
}

export function* fetchProfileNameWatcher() {
  yield takeEvery("GET_PROFILE_DATA", fetchProfileNameWorker);
}

export function* myProfileDetails(data) {
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionNameTypes.myProfileDetails,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionNameTypes.myProfileDetailsFailure,
      error
    });
    yield  handlerServerSideErrorsGlobal({error,type:"myAccountPageErr",redirect:'/',isRedirectfirst:true});
  }
}

export function* getCountriesList(data) {
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionNameTypes.countriesListType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionNameTypes.countriesListFailedType,
      error
    });
  }
}

/*************************** SAGA FOR FETCH PROFILE DATA ******************************/
export function* myProfileDataWorker(fetchPayload) {
  yield all([
    fork(myProfileDetails, fetchPayload.payload.metaData[0]),
    fork(getCountriesList, fetchPayload.payload.metaData[1])
  ]);
}
export function* myProfileDataNeedWorker(fetchPayload) {
  yield all([fork(myProfileDetails, fetchPayload.payload.metaData[0])]);
}

export function* fetchProfileDataWatcher() {
  yield takeEvery(actionNameTypes.myProfileDataSuccessType, myProfileDataWorker);
}

export function* fetchProfileDataNeedWatcher() {
  yield takeEvery(
    "MY_PROFILE_DATA_SUCCESS_NEEDASSISTANCE",
    myProfileDataNeedWorker
  );
}

/*************************** SAGA FOR POST CHANGE FUND NAME ******************************/

export function* postFundNameWorker(fetchPayload) {
  try {
    yield postJson.postCalls(fetchPayload.payload.metaData.url, {
      ...fetchPayload.payload.metaData.data
    },{isBhoomiUrl:fetchPayload.payload.metaData.isBhoomiUrl});
    yield put({
      type: actionNameTypes.saveNewFundNameSuccessType,
      payload: fetchPayload.payload.metaData.data.fundName
    });
  } catch (error) {
   yield  handlerServerSideErrorsGlobal({error})
   yield  handlerServerSideErrorsGlobal({error,type:"error504",errorCodes:[504]})

  }
}
export function* postFundNameWatcher() {
  yield takeEvery(actionNameTypes.saveNewFundNameType, postFundNameWorker);
}

/*************************** SAGA FOR POST CHANGE PRIMARY ACCOUNT ******************************/
export function* postPrimaryAccountWorker(fetchPayload) {
  yield put({
    type: actionNameTypes.primaryContactLoadingType,
    payload: ""
  });

  try {
    const response = yield call(submitData, fetchPayload.payload.metaData);
    let payload = {};
    payload.account = fetchPayload.payload.payload;
    payload.resp = response.data;
    let { prevData, name } = fetchPayload.payload;
    prevData.primaryAccountContact = fetchPayload.payload.metaData.data.contactData;
    prevData.accountAdvisors = prevData.accountAdvisors
      .map(item => {
        let advName =
          item.name.indexOf(",") === -1
            ? item.name
            : item.name.substring(0, item.name.indexOf(","));
        if (advName.trim() == name.trim()) {
          item.primaryAccountContact = true;
        } else {
          item.primaryAccountContact = false;
        }
        return item;
      });
    //if both the advisor are not primary setting the first one as the primary as arun suggested
    if (prevData.designatedParties && prevData.designatedParties.length > 0) {
      prevData.designatedParties.forEach(item => {
        let namedes = `${item.salutation ? item.salutation : ""} ${
          item.name ? item.name : ""
        } ${item.middleName ? item.middleName : ""} ${
          item.lastName ? item.lastName : ""
        }`;
        if (namedes.trim() == name.trim()) {
          item.primaryAccountContact = true;
        } else {
          item.primaryAccountContact = false;
        }
      });
    } 

    yield put({
      type: actionNameTypes.primaryContactSuccessType,
      payload: payload
    });

    yield put({
      type: actionNameTypes.myAccDataSuccessType,
      payload: prevData
    });

    yield put({
      type: actionNameTypes.primaryContactMyAccSuccessType,
    });
  } catch (error) {

    yield  handlerServerSideErrorsGlobal({error})
 
    yield  handlerServerSideErrorsGlobal({error,type:"error504",errorCodes:[504]})
  
    yield put({
      type: actionNameTypes.primaryContactFailedType,
      error
    });
  }
}
export function* postPrimaryAccountWatcher() {
  yield takeEvery(actionNameTypes.savePrimaryAccountType, postPrimaryAccountWorker);
}

/*************************** SAGA FOR POST CHANGE DESIGNATED ACCESSOR ******************************/
export function* postDesignatedAccessWorker(fetchReducerPayload) {
  try {

    const response = yield call(
      submitData,
      fetchReducerPayload.payload.metaData
    );

    if(response.relationships)
    {
      response.relationships.map((item)=>{
        fetchReducerPayload.payload.reducerData.map((designated)=>{
          if(item.relatedPartyId == designated.partyId)
          {
            designated.salesforceRelationshipId = item.salesforceRelationshipId
          }
        })
      })
    }

    let updatedReducerData = fetchReducerPayload.payload.reducerData.filter((red)=>{
      return red.isActive
    })
    yield put({
      type: actionNameTypes.designatedDataLoaderType,
    });
    fetchReducerPayload.payload.metaData.submitDone();
    yield put({
      type: actionNameTypes.designatedDataSuccType,
      payload: updatedReducerData
    });
  } catch (error) {
    yield handlerServerSideErrorsGlobal({error,type:"error504",errorCodes:[504],redirect:"/my-account"});
    yield handlerServerSideErrorsGlobal({error});
    fetchReducerPayload.payload.metaData.submitDone()

    yield put({
      type: actionNameTypes.designatedDataFailureType,
      payload: fetchReducerPayload.payload.currentReducer
    });
  }
}
export function* postDesignatedAccessWatcher() {
  yield takeEvery(actionNameTypes.designatedData, postDesignatedAccessWorker);
}

export function submitTableData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.myAccount.submitData(fetchPayload);
}

export function* postTableWorker(fetchPayload) {  
  try {    
    if (fetchPayload.payload.page === "myProfile") {
      yield put({
        type: actionNameTypes.tabaleDataSuccessType,
        payload: fetchPayload.payload.data
      });
    }
  } catch (error) {
    yield put({
      type: actionNameTypes.tableDataFailureType,
      error
    });
  }
}
export function* postTableWatcher() {
  yield takeEvery("DESIGNATED_DATA", postTableWorker);
}

/********************************************** SAGA FOR ADVISOR & SUCCESSION *********************************************/


export function* getZipCodeWorker(fetchPayload) {
  try {
    let response = yield fetchZipCodeData(fetchPayload);
    yield put({
      type: "GET_ZIPCODE1",
      payload: { response, fetchPayload: fetchPayload.payload }
    });
  } catch (error) {
    yield put({
      type: "ZIP_CODE_DATA_REQUEST_FAILED",
      error
    });
  }
}

export function fetchZipCodeData(fetchPayload) {
  let zipCodeData = "";
  const apiUrl = "http://ziptasticapi.com/" + fetchPayload.payload.zipCode;
  zipCodeData = fetch(apiUrl)
    .then(response => {
      if (!response.ok) {
        return null;
      } else {
        return response.json();
      }
    })
    .then(data => {
      if (data.error) {
        return null;
      } else {
        return data;
      }
    });
  return zipCodeData;
}

export function* OPADefaultWatcher() {
  yield takeEvery(actionNameTypes.fetchZipCode, getZipCodeWorker);
}

/********************************************** SAGA FOR EDIT SUCCESSION *********************************************/
export function fetchDropdownData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.myAccount.fetchAccountData(fetchPayload);
}
export function* dropdownDataFetch(data) {
  yield put({
    type: actionNameTypes.fetchDropDownLoaderValType,
    payload: ""
  });
  try {
    const response = yield call(fetchDropdownData, data);
    yield put({
      type: "GET_DROPDOWN_VALUES_SUCCESSS",
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: "GET_DROPDOWN_VALUES_FAILURE",
      error
    });
  }
}
export function* relationshipDataFetch(data) {
  yield put({
    type: actionNameTypes.fetchRelationDropDownLoaderValType,
    payload: ""
  });
  try {
    const response = yield call(fetchDropdownData, data);
    yield put({
      type: actionNameTypes.fetchRelationDropDownSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: "GET_RELATIONSHIP_VALUES_FAILURE",
      error
    });
  }
}
export function* fetchDropdownDataWorker(fetchPayload) {
  yield all([
    fork(dropdownDataFetch, fetchPayload.payload.metaData[0]),
    fork(relationshipDataFetch, fetchPayload.payload.metaData[1])
  ]);
}
export function* fetchDropdownDataWatcher() {
  yield takeEvery(actionNameTypes.fetchDropDownValType, fetchDropdownDataWorker);
}

export function fetchSuccessionData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.myAccount.fetchAccountData(fetchPayload);
}
export function* fetchSuccessionDataWorker(fetchPayload) {   //now fetchSuccessionDataWorker
  yield put({
    type: actionNameTypes.displaySuccessionValLoaderType,
    payload: ""
  });
  try {
    const response = yield call(
      fetchSuccessionData,
      fetchPayload.payload.metaData
    );
    yield put({
      type: actionNameTypes.displaySuccessionValSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionNameTypes.displaySuccessionValFailureType,
      error
    }); 
    yield  handlerServerSideErrorsGlobal({error,redirect:'/',isRedirectfirst:true});
  }
}
export function* fetchSuccessionDataWatcher() {
  yield takeEvery(actionNameTypes.displaySuccessionValType, fetchSuccessionDataWorker);
}

export function submitPostData(payload) {
  const submitInterface = asyncInterface.init();
  return submitInterface.myAccount.submitData(payload);
}
export function* submitAccountAdvisorWorker(submitPayload) {
  try {
    const response = yield call(submitPostData, submitPayload.payload);
    yield call(history.push, "/my-account");
    yield submitPayload.payload?.submitDone()
  } catch (error) {
    
   yield  handlerServerSideErrorsGlobal({error})
   yield  handlerServerSideErrorsGlobal({error,type:"error504",errorCodes:[504],redirect:"/my-account"})
    yield put({
      type: actionNameTypes.postAccountAdvErrType,
      error
    });
    yield submitPayload.payload?.submitDone()
  }
}
export function* submitAccountAdvisorWatcher() {
  yield takeLatest(actionNameTypes.postAccountAdvType, submitAccountAdvisorWorker);
}

export function* fetchDesignatedWorker(fetchPayload) {
  try {
    const response = yield call(
      fetchAccountData,
      fetchPayload.payload.metaData
    );
    yield put({
      type: actionNameTypes.addDesgnatedSuccess,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionNameTypes.addDesignatedFailedType,
      error
    });
  }
}
export function* addDesignatedWatcher() {
  yield takeEvery(actionNameTypes.addDesignatedType, fetchDesignatedWorker);
}

export function postUpdateSuccession(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.myAccount.submitData(fetchPayload);
}
export function* postUpdateSuccessionWorker(fetchPayload) {
  try {
    const response = yield call(postUpdateSuccession, fetchPayload.payload);
    yield put({ type: actionNameTypes.esphideSubmitLoader });
    yield call(history.push, "/my-account");
  } catch (error) {
    yield put({ type: actionNameTypes.esphideSubmitLoader });
    yield  handlerServerSideErrorsGlobal({error,redirect:'/',isRedirectfirst:true});
    yield put({
      type: actionNameTypes.updateLegacyFailureType,
      error
    });
  }
}
export function* postUpdateSuccessionWatcher() {
  yield takeEvery(actionNameTypes.updateSuccessionType, postUpdateSuccessionWorker);
}
export function* policiesFetch(data) {
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionNameTypes.successPoliciesType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionNameTypes.failedPoliciesType,
      error
    });
  }
}
export function* endowedFetch(data) {
  try {
    const response = yield call(fetchAccountData, data);
    yield put({
      type: actionNameTypes.endowedSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionNameTypes.endowedFailureType,
      error
    });
  }
}
export function* fetchGrantOptionPdfWorker(fetchPayload) {
  yield all([
    fork(policiesFetch, fetchPayload.payload.metaData[0]),
    fork(endowedFetch, fetchPayload.payload.metaData[1])
  ]);
}

export function* grantOptionPdfWatcher() {
  yield takeEvery(actionNameTypes.grantOptionPdfType, fetchGrantOptionPdfWorker);
}

/*********GENERATE ACCESS KEY**********************/

export function* fetchAccesskeyWorker(fetchPayload) {
  try {
    const response = yield call(
      fetchAccountData,
      fetchPayload.payload.metaData
    );
    yield put({
      type: actionNameTypes.accessKeySuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: actionNameTypes.accessKeyFailureType,
      error
    });
  }
}

export function* fetchAccessKeyWatcher() {
  yield takeEvery(actionNameTypes.generateAccessKeyType, fetchAccesskeyWorker);
}

/************************CHANGE DEFAULT ACCOUNT*************************/

export function* postDefaulAccountWorker(fetchPayload) {
  const changeDef = fetchPayload.payload.changeDef
    ? fetchPayload.payload.changeDef
    : 0;
  try {
    const response = yield call(submitData, fetchPayload.payload.metaData);
    yield put({
      type: actionNameTypes.tableDataUpdateSuccType,
      payload: fetchPayload.payload.metaData.data
    });
    yield put({
      type: actionNameTypes.defaultUpdateType,
      payload: changeDef
    });
  } catch (error) {
    yield put({
      type: actionNameTypes.tableDataUpdFailureType,
      error
    });
  }
}

export function* postDefaultAccountWatcher() {
  yield takeEvery(actionNameTypes.tableDataSuccessType, postDefaulAccountWorker);
}

/***********************EDIT PROFILE**************************/

export function submitProfileData(payload) {
  const submitInterface = asyncInterface.init();
  return submitInterface.myAccount.submitData(payload);
}

export function* submitProfileWorker(submitPayload) {
  try {
    const response = yield call(submitProfileData, submitPayload.payload);
    if (response.data === "Mandatory fields are missing") {
      yield put({
        type: actionNameTypes.postProfileErrorType
      });
    } else {
      yield call(history.push, "/my-profile");
    }
    yield submitPayload.payload?.submitDone()
  } catch (error) {
   yield  handlerServerSideErrorsGlobal({error})

   yield  handlerServerSideErrorsGlobal({error,type:"error504",errorCodes:[504],redirect:"/my-profile"})
 
   yield submitPayload.payload?.submitDone()

  }
}

export function* submitProfileWatcher() {
  yield takeLatest(actionNameTypes.postProfileType, submitProfileWorker);
}
/***********************INVITE PARTY**************************/

export function submitInviteData(payload) {
  const submitInterface = asyncInterface.init();
  return submitInterface.myAccount.submitData(payload);
}

export function* submitInviteWorker(submitPayload) {
  try {
    const response = yield call(submitInviteData, submitPayload.payload);
    yield put({ type: actionNameTypes.postInviteSuccessType, payload: response.data });
  } catch (error) {
   yield  handlerServerSideErrorsGlobal({error});

   yield  handlerServerSideErrorsGlobal({error,type:"error504",errorCodes:[504],redirect:"/my-account"})

    yield put({
      type: actionNameTypes.postInviteErrorType,
      error
    });
  }
}

export function* submitInviteWatcher() {
  yield takeLatest(actionNameTypes.postInviteType, submitInviteWorker);
}

/*****************************END HERE***********************************************/

/**********************Update User ID*******************************/

export function* PostUserIDWorker(fetchPayload) {
  try {
    const res = yield call(submitData, fetchPayload.payload.metaData[0]);
    if (res.data != "Username does not exist.") {
      yield put({
        type: actionNameTypes.userIndExistType,
        payload: res.data.userId
      });
      yield put({
        type: actionNameTypes.updatedUserIdApiResType,
        payload: true
      });
    } else {
      const response = yield call(submitData, fetchPayload.payload.metaData[1]);
      yield put({
        type: actionNameTypes.updatedUserIdApiResType,
        payload: true
      });

      if (response.data && response.data.toString().trim().toLowerCase() === 'ok') {
        yield put({
          type: actionNameTypes.userIdSuccessType,
          payload: response.data
        });        
      } else {
        yield put({
          type: actionNameTypes.userIdExistsType,
          payload: response.data
        });
      }
    }
  } catch (error) {
    yield put({
      type: actionNameTypes.updatedUserIdApiResType,
      payload: true
    });
    yield  handlerServerSideErrorsGlobal({error,isDirectlogout: true,errorCodes:[503],redirect:`${process.env.REACT_APP_DRUPAL_BASE_URL}?usererrorcode=503`});
    yield  handlerServerSideErrorsGlobal({error,type:"technicalErr",errorCodes:[500]});
  }
}

export function* addSecondaryAdvisorWorker(fetchPayload) {
  try {
    const response = yield call(submitData, fetchPayload.payload);
    yield put({
      type: actionNameTypes.addSecondaryAdvSuccType,
      payload: response.data
    });
    yield fetchPayload.payload?.submitDone()
  } catch (error) {
    yield put({
      type: actionNameTypes.addSecondaryAdvFailureType,
      error
    });
    
   yield  handlerServerSideErrorsGlobal({error})
   yield  handlerServerSideErrorsGlobal({error,type:"error504",errorCodes:[504],redirect:"/my-account"})

   yield fetchPayload.payload?.submitDone()
  }
}

export function* PostUserIDWatcher() {
  yield takeEvery(actionNameTypes.UpdateNewUserIdType, PostUserIDWorker);
}

export function* clearUserIdDataWorker(meta) {
  yield put({
    type: actionNameTypes.clearUpdUserIdType,
    payload: ""
  });
}

export function* clearUserIdDataWatcher() {
  yield takeLatest(actionNameTypes.clearChangeUserIdType, clearUserIdDataWorker);
}

/**********************Update MFA Email*******************************/

export function* PostmfaEmailWorker(fetchPayload) {
  try {
    const res = yield call(submitData, fetchPayload.payload.metaData[0]);
    if (res.data.message == 'Successfully updated.') {
      yield put({
        type: actionNameTypes.mfaEmailSuccessType,
        payload: res.data
      });
      yield put({
        type: actionNameTypes.updatedmfaEmailApiResType,
        payload: true
      });
    } else if(res.data.message == 'Email already exists. Try again.') {
      yield put({
        type: actionNameTypes.updatedmfaEmailApiResType,
        payload: true
      });

      yield put({
        type: actionNameTypes.mfaEmailExistType,
        payload: true
      });

    }else{
      yield put({
        type: actionNameTypes.updatedmfaEmailApiResType,
        payload: true
      });

      yield put({
        type: actionNameTypes.mfaEmailExistsType,
        payload: res.data.message
      });

    }
  } catch (error) {
    yield put({
      type: actionNameTypes.mfaEmailFailureType,
      error
    });
    yield put({
      type: actionNameTypes.updatedmfaEmailApiResType,
      payload: true
    });
  }
}
export function* PostmfaEmailWatcher() {
  yield takeEvery(actionNameTypes.UpdateNewmfaEmailType, PostmfaEmailWorker);
}

export function* clearmfaEmailDataWorker(meta) {
  yield put({
    type: actionNameTypes.clearUpdmfaEmailType,
    payload: ""
  });
}

export function* clearmfaEmailDataWatcher() {
  yield takeLatest(actionNameTypes.clearChangemfaEmailType, clearmfaEmailDataWorker);
}

export function* addSecondaryAdvisorWatcher() {
  yield takeLatest(actionNameTypes.addSecondaryAdvisorType, addSecondaryAdvisorWorker);
}

/***************************** End ****************************/

/**********************Resend Email*******************************/

export function* PostresendEmailWorker(fetchPayload) {
  try {    
    const res = yield call(submitData, fetchPayload.payload.metaData);
    if (res.data === "SUCCESS") {
      yield put({
        type: actionNameTypes.resendEmailSuccessType,
        payload: true
      });
    } else{
      yield put({
        type: actionNameTypes.resendEmailFailureType,
        payload: true
      });
    }
   } catch (error) {     
    yield put({
      type: actionNameTypes.resendEmailFailureType,
      error
    });
  }
}
export function* PostresendEmailWatcher() {
  yield takeEvery(actionNameTypes.resendEmailType, PostresendEmailWorker);
}

/********************** Change MFA phone number *******************************/

export function* PostchangeMFAPhNoWorker(fetchPayload) {
  try {
    const res = yield call(submitData, fetchPayload.payload.metaData);
    if (res.data.message === "MFA Phone no: successfully deleted") {
      yield put({
        type: actionNameTypes.changeMFAPhNoSuccessType,
        payload: true
      });
    } else{
      yield put({
        type: actionNameTypes.changeMFAPhNoFailureType,
        payload: true
      });
    }
   } catch (error) {
    yield put({
      type: actionNameTypes.changeMFAPhNoFailureType,
      error
    });
  }
}
export function* PostchangeMFAPhNoWatcher() {
  yield takeEvery(actionNameTypes.changeMFAPhNoType, PostchangeMFAPhNoWorker);
}

export default function* commonSagaWatcher() {
  yield all([
    fork(fetchAccountDataWatcher),
    fork(fetchProfileDataWatcher),
    fork(postTableWatcher),
    fork(OPADefaultWatcher),
    fork(fetchSuccessionDataWatcher),
    fork(fetchDropdownDataWatcher),
    fork(postDesignatedAccessWatcher),
    fork(postFundNameWatcher),
    fork(postPrimaryAccountWatcher),
    fork(postUpdateSuccessionWatcher),
    fork(submitAccountAdvisorWatcher),
    fork(grantOptionPdfWatcher),
    fork(addDesignatedWatcher),
    fork(fetchAccessKeyWatcher),
    fork(postDefaultAccountWatcher),
    fork(submitProfileWatcher),
    fork(submitInviteWatcher),
    fork(fetchProfileNameWatcher),
    fork(clearUserIdDataWatcher),
    fork(PostUserIDWatcher),
    fork(PostmfaEmailWatcher),
    fork(PostresendEmailWatcher),
    fork(PostchangeMFAPhNoWatcher),
    fork(addSecondaryAdvisorWatcher),
    fork(fetchAccountMappingWatcher),
    fork(fetchProfileDataNeedWatcher)
  ]);
}
